import axios from "@/utils/axios2";
import queryString from '../../utils/queryString';

export default {
    namespaced: true,
    state: {
        externalWorkshop: null,
        externalWorkshops: [],
        externalWorkshopMaintenances: null
    },
    mutations: {
        setExternalWorkshop(state, payload) {
            state.externalWorkshop = payload;
        },
        setExternalWorkshops(state, payload) {
            state.externalWorkshops = payload;
        },
        setExternalWorkshopMaintenances(state, payload) {
            state.externalWorkshopMaintenances = payload;
        },
        restExternalWorkshops(state) {
            state.externalWorkshops = [];
        }
    },
    actions: {
        fetchExternalWorkshop({commit, rootState}, payload) {
            return new Promise ((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `external-workshops/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    commit("setExternalWorkshop", response.data);
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        fetchExternalWorkshops({commit, rootState}, payload) {
            let query = queryString(payload);
            return new Promise ((resolve, reject) => {
                axios.request({
                    method: "get",
                    url:`external-workshops?${query}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    commit("setExternalWorkshops", response.data.data);
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response.data);
                })
            })
        },
        storeExternalWorkshop({rootState}, payload) {
            return new Promise ((resolve, reject) => {
                axios.request({
                    method: "post",
                    url: `external-workshops`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                })
            })
        },
        updateExternalWorkshop({rootState}, payload) {
            return new Promise ((resolve,reject) => {
                axios.request({
                    method: "put",
                    url: `external-workshops/${payload.id}`,
                    data: payload.form,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                })
            })
        },
        removeExternalWorkshop({rootState}, payload) {
            return new Promise ((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `external-workshops/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data)
                })
            })
        },
        fetchExternalWorkshopMaintenances({commit, rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: 'get',
                    url: `external-workshops/${payload}/maintenances`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    commit('setExternalWorkshopMaintenances', response.data);
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        restExternalWorkshops({ commit }) {
            commit('restExternalWorkshops');
        }
    }
}